import React, { useMemo, useState } from "react";
import SectionShell from "./SectionShell";

const FALLBACK_AVATAR_SRC = "/assets/review-avatars/review-avatar-fallback.webp";

function Stars({ value = 5 }) {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  return (
    <div className="cl-stars" aria-label={`${v} out of 5 stars`}>
      {"★★★★★".slice(0, v)}
      <span className="cl-starsMuted">
        {"★★★★★".slice(0, 5 - v)}
      </span>
    </div>
  );
}

export default function ReviewsCarousel({ heading, reviews }) {
  const list = Array.isArray(reviews) ? reviews : [];
  const [idx, setIdx] = useState(0);

  const current = useMemo(() => list[idx] || null, [list, idx]);

  /* ===== SKELETON STATE ===== */
  if (!list.length) {
    return (
      <div style={{ justifyContent:"center",display:'flex' }}>
      <SectionShell className="cl-reviews">
        {heading ? <div className="cl-h2">{heading}</div> : null}

        <div className="cl-reviewSkeleton">
          {[1, 2, 3].map((i) => (
            <div key={i} className="cl-reviewSkeletonCard">
              <div className="cl-skeleton cl-reviewSkeletonAvatar" />
              <div className="cl-skeleton cl-reviewSkeletonLine" />
              <div className="cl-skeleton cl-reviewSkeletonLine" />
              <div className="cl-skeleton cl-reviewSkeletonLine short" />
            </div>
          ))}
        </div>
      </SectionShell></div>
    );
  }

  return (
    <div style={{ justifyContent:"center",display:'flex' }}>
    <SectionShell className="cl-reviews">
      {/* {heading ? <div className="cl-h2">{heading}</div> : null} */}
      <div className="cl-h2">What Customers Are Saying</div>
      <div className="cl-reviewGrid">
        {/* 2-up layout: current + next */}
        {[0, 1].map((offset) => {
          const r = list[(idx + offset) % list.length];
          if (!r) return null;

          return (
            <div className="cl-reviewCard" key={`${r.name}-${offset}`}>
              <div className="cl-reviewAvatar">
                <img
                  src={r.avatarSrc || r.avatarUrl || FALLBACK_AVATAR_SRC}
                  alt={r.avatarAlt || `Avatar for ${r.name || "customer"}'s review`}
                  width="64"
                  height="64"
                  loading="lazy"
                />
              </div>
              <div className="cl-reviewName">{r.name}</div>
              <Stars value={r.rating} />
              <div className="cl-reviewQuote">“{r.quote}”</div>
            </div>
          );
        })}
      </div>

      <div className="cl-dots">
        {list.map((_, i) => (
          <button
            key={i}
            className={`cl-dot ${i === idx ? "isActive" : ""}`}
            onClick={() => setIdx(i)}
            aria-label={`Show review set ${i + 1}`}
            type="button"
          />
        ))}
      </div>
    </SectionShell></div>
  );
}
